import ImageGallery from '@uikit/components/ImageGallery/ImageGallery';
import { ImageGalleryProps } from './interfaces';

const MagazineImageSlider = ({ contents }: ImageGalleryProps) => {
  const items =
    contents?.[0].contents.map(({ props }) => ({
      props,
    })) ?? [];

  return (
    <ImageGallery
      contents={[
        {
          contents: items.map(({ props }) => ({ props })),
        },
      ]}
    />
  );
};

export default MagazineImageSlider;
